export default __webpack_public_path__ + "static/media/no-permission.8a18cc27.png";